import { useEffect, useMemo, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { PageHeader, StatusBadge, BasisBadge } from "@/components/app/ui";
import { SectionHelp } from "@/components/app/Help";
import { FactsPanel } from "@/pages/Organisation";
import { api, fmtDate } from "@/lib/api";
import { RuleInfo } from "@/components/app/RuleInfo";

export default function Applicability() {
  const [d, setD] = useState(null);
  const [onlyApp, setOnlyApp] = useState(false);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/applicability").then((r) => setD(r.data)); }, []);
  const rows = useMemo(() => (d?.controls || []).filter((c) => (!onlyApp || c.applicable) && `${c.id} ${c.name} ${c.domain} ${c.section_or_rule}`.toLowerCase().includes(q.toLowerCase())), [d, onlyApp, q]);
  if (!d) return null;
  const n = d.controls.filter((c) => c.applicable).length;
  return (
    <div className="space-y-6">
      <PageHeader title="Applicability" subtitle={`${n} of ${d.controls.length} controls apply. Applicability logic is evaluated separately from assessment logic, and effective dates determine regulatory status.`} />
      <SectionHelp id="applicability" />
      <FactsPanel facts={d.facts} />
      <div className="flex flex-wrap items-center gap-4">
        <Input placeholder="Search controls, sections…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs bg-white" data-testid="applicability-search" />
        <label className="flex items-center gap-2 text-sm text-slate-600"><Switch checked={onlyApp} onCheckedChange={setOnlyApp} data-testid="applicability-only-toggle" />Applicable only</label>
      </div>
      <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm" data-testid="applicability-table">
          <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-2.5">Control</th><th className="px-4 py-2.5">Basis / Source</th><th className="px-4 py-2.5">Applicability expression</th><th className="px-4 py-2.5">Effective</th><th className="px-4 py-2.5">Regulatory status</th></tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} data-testid={`applicability-row-${c.id}`} className={`border-t align-top ${c.applicable ? "" : "bg-slate-50/60 text-slate-400"}`}>
                <td className="px-4 py-3"><div className="font-mono text-xs text-slate-500">{c.id}</div><div className="font-medium text-slate-800">{c.name} <RuleInfo c={c} /></div><div className="text-xs text-slate-500">{c.domain}</div></td>
                <td className="px-4 py-3"><BasisBadge basis={c.basis_type} /><div className="mt-1 text-xs"><span className="legal-ref">{c.section_or_rule}</span></div></td>
                <td className="px-4 py-3 max-w-md"><code className="text-[11px] text-indigo-700">IF {c.applicability_expr}</code><div className="mt-1 text-xs text-slate-500">{c.reason}</div></td>
                <td className="px-4 py-3 whitespace-nowrap text-xs">{c.effective_from ? fmtDate(c.effective_from) : "Non-statutory"}</td>
                <td className="px-4 py-3"><StatusBadge status={c.reg_status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
